import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import "@/landing.css";
import LandingNav from "@/components/landing/LandingNav";
import Hero from "@/components/landing/Hero";
import DualPath from "@/components/landing/DualPath";
import HowItWorks from "@/components/landing/HowItWorks";
import GamesStrip from "@/components/landing/GamesStrip";
import ForCoaches from "@/components/landing/ForCoaches";
import Promises from "@/components/landing/Promises";
import Faq from "@/components/landing/Faq";
import FinalCta from "@/components/landing/FinalCta";
import LandingFooter from "@/components/landing/LandingFooter";

export default function Landing() {
  const { user, loading } = useAuth();
  if (loading) return <div className="route-loading" aria-busy="true" />;
  if (user) return <Navigate to="/dashboard" replace />;
  return (
    <div className="landing">
      <LandingNav />
      <main>
        <Hero />
        <DualPath />
        <HowItWorks />
        <GamesStrip />
        <ForCoaches />
        <Promises />
        <Faq />
        <FinalCta />
      </main>
      <LandingFooter />
    </div>
  );
}
